import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { CSSProperties, ReactNode } from 'react';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';

import { findRewardThresholdColor } from 'lib/wheelReward';

import type { Shape_probabilisticBundleSlotConfig } from './__generated__/index.graphql';

type Props = {
  config: Shape_probabilisticBundleSlotConfig;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  rarity: Rarity;
};

export const Shape = ({
  config,
  children,
  className,
  style,
  rarity,
}: Props) => {
  const color = findRewardThresholdColor(config, rarity);

  return (
    <Bezel
      background={`linear-gradient(
      to bottom,
      transparent calc(100% - 10px),
      ${color} 10px
    ),
    radial-gradient(var(--c-nl-50) 0%, var(--c-nl-900) 100%),
    linear-gradient(var(--c-nl-900) 0%, var(--c-nl-50 ) 50%),
    linear-gradient(${color} 0%, ${color} 100%),
    linear-gradient(var(--c-nl-50-opaque) 0%, var(--c-nl-50-opaque) 100%)`}
      style={{ ...style, padding: '0 0 var(--unit)', height: '100%' }}
      className={className}
    >
      {children}
    </Bezel>
  );
};

Shape.fragments = {
  ProbabilisticBundleSlotConfig: gql`
    fragment Shape_probabilisticBundleSlotConfig on ProbabilisticBundleSlotConfig {
      id
      ...findRewardThresholdColor_probabilisticBundleSlotConfig
    }
    ${findRewardThresholdColor.fragments.probabilisticBundleSlotConfig}
  ` as TypedDocumentNode<Shape_probabilisticBundleSlotConfig>,
};
